module.exports = __webpack_public_path__ + "media/images/menu/m9-a1f38ed64c9e6ef96a8696e0a5b0ff9f.JPG";